import React from "react";
import { arrayOf, string, number, objectOf, shape } from "prop-types";
import { HorizontalBar } from "react-chartjs-2";
import i18n from "../lib/i18n";
import {
  tooltipColorSettings,
  barLegendSettings,
  eventSettings,
} from "../lib/chartHelpers";
import colors from "@/stylesheets/colors.module.scss";
import _ from "lodash";

const ClimateRisksBarChart = ({ sorted_labels, series }) => {
  const high = {
    label: i18n.t("js.components.climate_risks_bar_chart.label.high"),
    backgroundColor: colors.climate_risk_high,
    data: sorted_labels.map((label) => series[label]?.high || 0),
    maxBarThickness: 18,
  };
  const medium = {
    label: i18n.t("js.components.climate_risks_bar_chart.label.medium"),
    backgroundColor: colors.climate_risk_medium,
    data: sorted_labels.map((label) => series[label]?.medium || 0),
    maxBarThickness: 18,
  };

  // Calculate height for labels and padding + height based on number of bars
  const height = 50 + sorted_labels.length * 36;

  return (
    <div style={{ height: height }}>
      {sorted_labels.length === 0 ? (
        <p className="text-center">
          {i18n.t("js.components.climate_risks_bar_chart.empty_graph")}
        </p>
      ) : (
        <HorizontalBar
          data={{ datasets: [high, medium], labels: sorted_labels }}
          options={{
            legend: barLegendSettings,
            maintainAspectRatio: false,
            devicePixelRatio: 2,
            ...eventSettings,
            tooltips: {
              mode: "nearest",
              callbacks: {
                label: function (tooltipItem, data) {
                  const datasetLabel =
                    data.datasets[tooltipItem.datasetIndex].label;
                  return (
                    datasetLabel +
                    ": " +
                    i18n.t(
                      "js.components.climate_risks_bar_chart.tooltip.facilities",
                      { count: tooltipItem.xLabel }
                    )
                  );
                },
                footer: function (tooltipItems) {
                  return i18n.t(
                    "js.components.climate_risks_bar_chart.tooltip.total_facilities",
                    {
                      count: _.sumBy(tooltipItems, "xLabel"),
                    }
                  );
                },
              },
              ...tooltipColorSettings,
            },
            scales: {
              xAxes: [
                {
                  stacked: true,
                  ticks: {
                    min: 0,
                    stepSize: 1,
                  },
                },
              ],
              yAxes: [
                {
                  stacked: true,
                  gridLines: {
                    display: false,
                  },
                },
              ],
            },
          }}
        />
      )}
    </div>
  );
};

export default ClimateRisksBarChart;

ClimateRisksBarChart.propTypes = {
  sorted_labels: arrayOf(string).isRequired,
  series: objectOf(
    shape({
      high: number.isRequired,
      medium: number.isRequired,
    })
  ),
};
